// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__k7f4b","buttons":"PendingPaymentAlert_buttons__1PKgX"};